import { ConfigsLoaderService } from 'src/app/services/configs-loader.service';
import { EnumTipoMensagem } from 'src/app/structure/enum/enum-infra';
import { MessageInfra } from 'src/app/structure/message/message-infra';
import { MessageService } from 'src/app/structure/service/message.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, CanLoad } from '@angular/router';
import { JwtService } from './jwt.service';

@Injectable()
export class AuthGuardInicialService implements CanActivate {

  constructor(private router: Router, private jwtService: JwtService, private messageService: MessageService, private configsLoaderService: ConfigsLoaderService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
  {
    if (this.jwtService.hasToken()) {
      this.messageService.showNotify(MessageInfra.SessaoExisteAtiva, EnumTipoMensagem.Alerta);
      this.router.navigateByUrl('/home')
      return false;
    }

    return true;
  }
}
